import { Hidden } from "@material-ui/core";
import React from "react";
import { STDrawer } from "./styles";
import { inject, observer } from "mobx-react";
import { IAuthStore } from "@src/Stores/Auth/types";
import { IValuesStore } from "@src/Stores/Values/types";

import { IMenuListProps } from "@src/Components/Pages/Main/MenuList/MenuList";
import { RouterStore } from "mobx-react-router";

interface IProps {
  auth?: IAuthStore;
  values?: IValuesStore;
  routing?: RouterStore;
  drawerOpened: boolean;
  onDrawerToggle: () => void;
  menuListComponent: React.ReactType<IMenuListProps>;
}

@inject("auth", "values", "routing")
@observer
class SideMenu extends React.Component<IProps> {
  render() {
    const MenuList: React.ReactType<IMenuListProps> = this.props
      .menuListComponent;
    return (
      <nav>
        <Hidden mdUp implementation="js">
          <STDrawer
            variant="temporary"
            open={this.props.drawerOpened}
            anchor="left"
            onClose={this.props.onDrawerToggle}
          >
            <MenuList onDrawerToggle={this.props.onDrawerToggle} />
          </STDrawer>
        </Hidden>
        <Hidden smDown implementation="css">
          <STDrawer variant="permanent" open>
            <MenuList onDrawerToggle={this.props.onDrawerToggle} />
          </STDrawer>
        </Hidden>
      </nav>
    );
  }
}

export default SideMenu;
